<template>
  <div>
    <Row>
      <Col span="24">
      <MyNotice :style="{display: cloudshow?'block':'none'}"></MyNotice>
      <MyHistory :style="{display: historyshow?'block':'none'}"></MyHistory>
     <!--  <Divider orientation="left" dashed>以下为搜索引擎</Divider> -->
      </Col>
    </Row>
    <!-- <SearchEngine></SearchEngine> -->
  </div>
</template>
<script>
// import tableresult from './../common/common_engine/resulttable.vue'
// import SearchEngine from './../common/common_engine/searchengine.vue'
// import treatyEngine from './../common/common_engine/treatyengine.vue'
// import ForeignTrade from './../common/common_engine/foreign_trade.vue'
import SearchEngine from './../common/common_engine/search_main.vue'
import AssistantCloudNotice from './assistant_cloud_notice.vue'
import AssistantHistory from './assistant_history.vue'
export default {
  name: "Assistant_Content_Main",
  inject: ["reload"],
  data() {
    return {
      value1: ["1", "2"],
      classid: "",
      pageType: "",
      cloudshow: false,
      historyshow: false,
    }
  },
  provide() {
    return {
      expand: this.expand
    }
  },
  components: {
    // 'SearchResult': tableresult,
    // 'SearchEngine': SearchEngine,
    // 'treatyEngine': treatyEngine,
    // 'TradeEngine': ForeignTrade,
    'SearchEngine':SearchEngine,
    'MyNotice':AssistantCloudNotice,
    'MyHistory':AssistantHistory,
  },
  created(){

  },
  methods: {
    expand() {
      this.vaule1 = ["1", "2"];
      this.reload();

    },
    // setstatus(data) {

    // },
    // fliterHeader(obj) {
    //   this.$refs.search_rlt.reloadHeaderData(obj);
    // },
    // setmsgpad() {
    //   this.$refs.treatengine01.setSmallPadLeft();
    // }

  },
  mounted: function() {
    this.pageType = this.$route.query.q_type
    if (this.pageType == "cloudmsg") {
      this.cloudshow = true;
    } else if (this.pageType == "cloudhistory") {
      this.historyshow = true;
    } else {
      this.cloudshow = true;
    }
    //console.log(this.classid)
  },

  // watch:{
  //  "$route":function(to,from){
  //    console.log(to.query.userid)
  //  }
  // }

}

</script>
<style scoped>
.cpllapse-panel-title {
  font-size: 12px;
}

.expand-row {
  margin-bottom: 16px;
}

</style>
